import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgxInnerLoadingModule } from 'ngx-inner-loading';

import { PatientGroupRowModule } from '../patient-group-row/patient-group-row.module';
import { PatientGroupListComponent } from './patient-group-list.component';

@NgModule({
  declarations: [PatientGroupListComponent],
  imports: [CommonModule, NgxInnerLoadingModule, PatientGroupRowModule],
  exports: [PatientGroupListComponent],
})
export class PatientGroupListModule {}
